import React, {useState, useEffect, useCallback} from 'react';
import {Route, Switch} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
// import {loadUser, logoutUser} from '@store/reducers/auth';
import MenuSidebar from '@modules/layouts/sidebar/MainMenuSidebar';
import Blank from '@app/pages/Blank';
import CorporateInvite from '@modules/corporate-invite/index';
import ManageInvites from '@modules/corporate-invite/ManageInvites';
import CorporateRequest from '@modules/helpdesk/CorporateRequests';
import CalculateEngine from '@modules/calculate-engine';
import ManageCategorySources from '@modules/calculate-engine/ManageCategorySources';
import ManageSourceInputTable from '@modules/calculate-engine/ManageSourceInputTable';
import ManageSourceInputTableData from '@modules/calculate-engine/ManageSourceInputTableData';
import ManageSourceEquations from '@modules/calculate-engine/ManageSourceEquations';
import ManageUnits from '@modules/calculate-engine/ManageUnits';
import UpdateEntity from '@modules/entity/UpdateEntity';
import AddActivity from '@modules/activity/AddActivity';
import ManageActivities from '@modules/activity/index';
import OwnerCorporateStructure from '@modules/corporate/OwnerCorporateStructure';
import AnnualReports from '@modules/reports/AnnualReports';
import {MainLoader} from '@components';
import Dashboard from '@app/pages/Dashboard';

import ManageValidatorInvites from '@modules/validators/ManageInvites';
import ValidatorSendInvite from '@modules/validators/SendInvite';
import CorpReports from '@modules/validators/CorpReports';
import CorpReportReview from '@modules/validators/CorpReportReview';

import Header from './header/HeaderMain';
import Footer from './footer/FooterMain';

import {toggleSidebarMenu} from './redux';

const Main = () => {
  const dispatch = useDispatch();
  const isSidebarMenuCollapsed = useSelector(
    (state) => state.layout.isSidebarMenuCollapsed
  );
  const screenSize = useSelector((state) => state.layout.screenSize);

  const [isAppLoaded, setIsAppLoaded] = useState(false);

  const handleToggleMenuSidebar = () => {
    dispatch(toggleSidebarMenu());
  };

  const fetchProfile = async () => {
    try {
      // dispatch(loadUser(response));
      setIsAppLoaded(true);
    } catch (error) {
      // dispatch(logoutUser());
      setIsAppLoaded(true);
    }
  };

  useEffect(() => {
    const bodyEl = document.getElementsByTagName('body')[0];
    document.getElementById('root').classList.remove('register-page');
    document.getElementById('root').classList.remove('login-page');
    document.getElementById('root').classList.remove('hold-transition');

    bodyEl.classList.add('sidebar-mini');
    bodyEl.classList.add('layout-fixed');

    fetchProfile();
    return () => {
      bodyEl.classList.remove('sidebar-mini');
      bodyEl.classList.remove('layout-fixed');
    };
  }, []);

  useEffect(() => {
    const bodyEl = document.getElementsByTagName('body')[0];
    bodyEl.classList.remove('sidebar-closed');
    bodyEl.classList.remove('sidebar-collapse');
    bodyEl.classList.remove('sidebar-open');
    if (isSidebarMenuCollapsed && screenSize === 'lg') {
      // bodyEl.classList.add('sidebar-collapse'); // not required in lg not showing toggle
    } else if (isSidebarMenuCollapsed && screenSize === 'xs') {
      bodyEl.classList.add('sidebar-open');
    } else if (!isSidebarMenuCollapsed && screenSize !== 'lg') {
      bodyEl.classList.add('sidebar-closed');
      bodyEl.classList.add('sidebar-collapse');
    }
  }, [screenSize, isSidebarMenuCollapsed]);

  const getAppTemplate = useCallback(() => {
    if (!isAppLoaded) {
      return (
        <MainLoader
          minHeight="100vh"
          spinnerColor="#479541"
          background="rgba(0,0,0,0.2)"
        />
      );
    }
    return (
      <>
        <Header toggleMenuSidebar={handleToggleMenuSidebar} />

        <MenuSidebar toggleMenuSidebar={handleToggleMenuSidebar} />

        <div className="content-wrapper cce-content-wrapper cce-sidebar-margin-left">
          <div className="pt-3 pt-lg-0" />
          <section className="content">
            <Switch>
              <Route exact path="/activities" component={ManageActivities} />
              <Route exact path="/reporter/validations" component={Blank} />
              <Route exact path="/reports" component={AnnualReports} />
              <Route
                exact
                path="/corporates/invites"
                component={ManageInvites}
              />
              <Route
                exact
                path="/corporates/send-invite"
                component={CorporateInvite}
              />
              <Route
                exact
                path="/corporates/pending"
                component={CorporateRequest}
              />
              <Route
                exact
                path="/facilities/:entityId"
                component={UpdateEntity}
              />
              <Route
                exact
                path="/subsidiaries/:entityId"
                component={UpdateEntity}
              />
              <Route exact path="/activities/add" component={AddActivity} />
              <Route
                exact
                path="/corporates/approved"
                component={OwnerCorporateStructure}
              />

              <Route exact path="/calc-engine/units" component={ManageUnits} />

              <Route
                exact
                path="/calc-engine/:categoryId/sources/:sourceId/input-table-fields"
                component={ManageSourceInputTable}
              />

              <Route
                exact
                path="/calc-engine/:categoryId/sources/:sourceId/input-table-data"
                component={ManageSourceInputTableData}
              />

              <Route
                exact
                path="/calc-engine/:categoryId/sources/:sourceId/equations"
                component={ManageSourceEquations}
              />

              <Route
                exact
                path="/calc-engine/:categoryId/sources"
                component={ManageCategorySources}
              />

              <Route exact path="/calc-engine" component={CalculateEngine} />

              <Route
                exact
                path="/validators/invites"
                component={ManageValidatorInvites}
              />
              <Route
                exact
                path="/validators/send-invite"
                component={ValidatorSendInvite}
              />

              <Route
                exact
                path="/validators/reports/review/:reportId"
                component={CorpReportReview}
              />

              <Route exact path="/validators/reports" component={CorpReports} />

              <Route exact path="/" component={Dashboard} />
            </Switch>
          </section>
        </div>
        <Footer />
        <div
          id="sidebar-overlay"
          role="presentation"
          onClick={handleToggleMenuSidebar}
          onKeyDown={() => {}}
        />
        <div id="cce-confirm-model-container" />
      </>
    );
  }, [isAppLoaded]);

  return <div className="wrapper">{getAppTemplate()}</div>;
};

export default Main;
